import {Modal, Button} from 'react-bootstrap'

interface Props {
  show: boolean
  title: string
  description: string
  confirmLabel?: string
  confirmVariant?: 'primary' | 'danger'
  loading?: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ModalConfirmAction: React.FC<Props> = ({
  show,
  title,
  description,
  confirmLabel = 'Confirmar',
  confirmVariant = 'primary',
  loading,
  onCancel,
  onConfirm,
}) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{description}</Modal.Body>
    <Modal.Footer>
      <Button variant='light' onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button variant={confirmVariant} onClick={onConfirm} disabled={loading}>
        {loading ? 'Processing...' : confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
)
